import { useUserActions } from "@src/utils/hooks/useUserActions";
import "./needLogin.scss";
import { linkLogin, linkSignup } from "@src/utils/login";
import { NoData, ButtonWrap, ButtonBox } from "@shared/src";

type Props = {
  desc?: string;
};

/**
 * 로그인이 필요한 서비스 안내 컴포넌트
 */
const NeedLogin = ({ desc = "로그인하고 맞춤 컨텐츠와 다양한 혜택을 받으세요." }: Props) => {
  const { resetUserData } = useUserActions();

  return (
    // <div className="need-login-wrap">
    //   <i>😢</i>
    //   <b>로그인이 필요한 서비스입니다</b>
    //   <p>로그인하고 맞춤 컨텐츠와 다양한 혜택을 받으세요.</p>
    //   <div className="btn-wrap btn-wrap-no-padding">
    //     <button
    //       className="btn bold btn-small brown500"
    //       onClick={() => {
    //         resetUserData();
    //         linkLogin();
    //       }}
    //     >
    //       로그인하기
    //     </button>
    //     <button
    //       className="btn bold btn-small btn-brown500"
    //       onClick={() => {
    //         resetUserData();
    //         linkSignup();
    //       }}
    //     >
    //       회원 가입하기
    //     </button>
    //   </div>
    // </div>
    <NoData
      icon="😢"
      title="로그인이 필요한 서비스입니다"
      desc={desc}
      extra={
        <ButtonWrap noPaddingPosition="all">
          <ButtonBox
            text="로그인하기"
            onClick={() => {
              resetUserData();
              linkLogin();
            }}
            size="small"
            theme="brown0"
            transparent={"bg"}
            isBold={true}
          ></ButtonBox>
          <ButtonBox
            text="회원 가입하기"
            onClick={() => {
              resetUserData();
              linkSignup();
            }}
            size="small"
            theme="brown500"
          ></ButtonBox>
        </ButtonWrap>
      }
    />
  );
};

export default NeedLogin;
